export default "__VITE_ASSET__DAjc_woD__"